<template>
    <SlideIntroLayout class="override" :videoUrl="require('@/assets/vids/intro-2.mp4')" :slideIndex="1" :durationMs="6000" nextPageId="AlphaGoat01S3">
        <template #description>
            Your Exclusive Pass to the Alpha G.O.A.T Inner Circle
        </template>
    </SlideIntroLayout>
</template>
